<template>
  <div class="product-blogs">
    <h2 class="base-section__title text--center" v-if="section?.title">
      {{ section.title }}
    </h2>
    <div class="product-blogs__content">
      <div v-for="(item, index) of transformedProps" :key="index">
        <sib-link
          :to="item.url"
          :title="item.title"
          class="product-blogs__thumbnail"
        >
          <sib-image v-bind="item"></sib-image>
        </sib-link>

        <div class="product-blogs__post-title">
          <sib-link :to="item.url" :title="item.title">
            {{ item.title }}
          </sib-link>
        </div>
      </div>
    </div>
    <div
      class="product-blogs__explore-more text--center mt-sm"
      v-if="section?.exploreMore?.title"
    >
      <sib-link
        :to="section.exploreMore.url"
        :title="section.exploreMore.title"
      >
        {{ section.exploreMore.title }}
      </sib-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from '@vue/reactivity'

const props = withDefaults(defineProps<{ section: any }>(), {})

const transformedProps = computed(() => {
  return props.section?.items.map((item) => {
    return {
      width: 640,
      height: 640,
      src: item.image,
      alt: item.title,
      title: item.title,
      url: item.url,
      loading: 'lazy',
      sources: [
        {
          size: 160,
        },
        {
          size: 270,
          media: 361,
        },
        {
          size: 360,
          media: 580,
        },
        {
          size: 200,
          media: 768,
        },
        {
          size: 230,
          media: 992,
        },
        {
          size: 270,
          media: 1200,
        },
        {
          size: 400,
          media: 1400,
        },
      ],
      generateSrcSet: true,
    }
  })
})
</script>

<style lang="scss">
.product-blogs {
  &__content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    @include media-md-up() {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
  }

  &__thumbnail {
    display: flex;
    flex-direction: column;

    img {
      border-radius: var(--border-radius-large);
      object-fit: cover;
    }
  }

  &__post-title a {
    font-size: 12px;
    margin-top: 0.5rem;
    font-weight: var(--fw-regular);
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    max-height: 4.5em;
    overflow: hidden;
    @include media-md-up() {
      margin-top: 1rem;
      font-size: 18px;
    }
  }

  &__explore-more a {
    font-size: var(--text-size);
    color: #15609b;
    text-decoration: underline;
    line-height: 1;
  }
}
</style>
